import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { FontAwesomeIconWrapper } from '@icon/fontawesome/FontAwesomeIconWrapper';
/**
 * @export
 * LoadingFeedback - A user-friendly loading overlay component
 * Blocks UI interaction and provides clear visual feedback
 *
 * @example
 * ```tsx
 * <LoadingFeedback
 *   show={isLoading}
 *   message="Processing your request"
 *   submessage="Please wait..."
 *   progress={45}
 * />
 * ```
 */
export const LoadingFeedback = ({ show, message = 'Loading...', submessage, progress, icon, }) => {
    const [displayMessage, setDisplayMessage] = useState(message);
    const [isAnimating, setIsAnimating] = useState(false);
    // Animate message changes
    useEffect(() => {
        if (message !== displayMessage) {
            setIsAnimating(true);
            const timer = setTimeout(() => {
                setDisplayMessage(message);
                setIsAnimating(false);
            }, 150);
            return () => clearTimeout(timer);
        }
    }, [message, displayMessage]);
    if (!show)
        return null;
    const getIcon = () => {
        if (icon)
            return icon;
        return ['fal', 'spinner-third'];
    };
    return (_jsxs("div", { className: "uxpcore_loading_feedback__overlay", children: [_jsx("div", { className: "uxpcore_loading_feedback__backdrop" }), _jsxs("div", { className: "uxpcore_loading_feedback__content", children: [_jsx("div", { className: "uxpcore_loading_feedback__icon uxpcore_loading_feedback__icon--spin", children: _jsx(FontAwesomeIconWrapper, { icon: getIcon() }) }), _jsx("div", { className: `uxpcore_loading_feedback__message ${isAnimating ? 'uxpcore_loading_feedback__message--fade' : ''}`, children: displayMessage }), submessage && (_jsx("div", { className: "uxpcore_loading_feedback__submessage", children: submessage })), typeof progress === 'number' && (_jsxs("div", { className: "uxpcore_loading_feedback__progress", children: [_jsx("div", { className: "uxpcore_loading_feedback__progress-bar", children: _jsx("div", { className: "uxpcore_loading_feedback__progress-fill", style: { width: `${Math.min(100, Math.max(0, progress))}%` } }) }), _jsxs("div", { className: "uxpcore_loading_feedback__progress-text", children: [Math.round(progress), "%"] })] })), _jsxs("div", { className: "uxpcore_loading_feedback__dots", children: [_jsx("span", {}), _jsx("span", {}), _jsx("span", {})] })] })] }));
};
export default LoadingFeedback;
